import $ from "jquery";
import gsap from "gsap";
$(document).on("click", 'a[href^="#"]', function (event) {
  let headerHeight = $("header").outerHeight();
  event.preventDefault();

  $("html, body").animate(
    {
      scrollTop: $($.attr(this, "href")).offset().top - headerHeight,
    },
    750
  );
});

$(window).on("load resize", function () {
  let headerHeight = $("header").outerHeight();
  $("nav").css("top", `${headerHeight}px`);
});

$("header button").on("click", function () {
  $(this).toggleClass("is-active");
  $("body, html").toggleClass("lock");
  if ($(this).hasClass("is-active")) {
    gsap.to("nav", {
      autoAlpha: 1,
      duration: 0.5,
    });
    gsap.to("nav li", {
      y: "0rem",
      opacity: 1,
      stagger: 0.1,
    });
  } else {
    gsap.to("nav", {
      autoAlpha: 0,
      duration: 0.5,
      clearProps: "visibility,opacity",
    });
    gsap.to("nav li", {
      opacity: 0,
      y: "3rem",
      duration: 0.5,
      clearProps: "transform,opacity",
    });
  }
});

$("header a").on("click", function () {
  $("header button").removeClass("is-active");
  $("body, html").removeClass("lock");
  gsap.to("nav", {
    autoAlpha: 0,
    duration: 0.5,
  });
  gsap.to("nav li", {
    opacity: 0,
    y: "3rem",
    duration: 0.5,
  });
});
